<template>
    <div class="flex flex-col items-center mx-auto w-full max-w-[19.5rem] large:my-auto large:pb-[7.6875rem] large:max-w-[26.25rem]">
        <div
            v-if="$root.config.emailOptIn.content.heading"
            class="heading-s mb-3 text-center xLarge:mb-4"
        >
            {{ $root.config.emailOptIn.content.heading }}
    </div>
        <div
            v-if="$root.config.emailOptIn.content.description"
            class="wysiwyg body-s text-center"
            v-html="descriptionHtml"
        />
        <div
            v-if="$root.config.emailOptIn.content.formHtml"
            class="mt-6 w-full xLarge:mt-[3.125rem]"   
            v-html="formHtml"
        />
        <div
            v-if="$root.config.emailOptIn.canSkip"
            class="mt-4 xLarge:mt-5"
        >
            <button
                type="button"
                class="body-xs underline"
                @click="goToNext"
            >
                {{ $root.config.translations.emailOptIn.skipThisStep }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                klaviyoLoaded: false,
                form: null
            }
        },
        computed: {
            descriptionHtml() {
                // Unescapes HTML entities
                const tempEl = document.createElement('textarea');
                tempEl.innerHTML = this.$root.config.emailOptIn.content.description;

                // Parses as DOM so values can be changed
                const parser = new DOMParser();
                let htmlBody = parser.parseFromString(tempEl.value, 'text/html');

                // Returns modified parsed HTML
                return htmlBody.body.innerHTML;
            },
            formHtml() {
                // Unescapes HTML entities
                const tempEl = document.createElement('textarea');
                tempEl.innerHTML = this.$root.config.emailOptIn.content.formHtml;

                // Parses as DOM so values can be changed
                const parser = new DOMParser();
                let htmlBody = parser.parseFromString(tempEl.value, 'text/html');

                // Returns modified parsed HTML
                return htmlBody.body.innerHTML;
            }
        },
        mounted () {
            if (!window.klaviyo && this.$root.config.emailOptIn.klaviyoAPIKey) {
                !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

                const script = document.createElement('script')
                
                script.type = 'text/javascript';
                script.async = true;
                script.src = `//static.klaviyo.com/onsite/js/${this.$root.config.emailOptIn.klaviyoAPIKey}/klaviyo.js`;

                document.body.appendChild(script);

                script.addEventListener('load', () => {
                    this.klaviyoLoaded = true;
                });
            } else if (window.klaviyo) {
                // Assumed injected via Shopify App embed
                this.klaviyoLoaded = true;
            }

            this.$nextTick(() => {
                this.form = this.$el.querySelector('form');

                if (this.form) {
                    this.form.querySelector('[name="return_to"]').value = `${window.location.pathname}${window.location.hash}/true/results`;

                    this.form.addEventListener('submit', event => {
                        event.stopImmediatePropagation();
                        event.preventDefault();

                        // guard against double submits
                        if (this.isSubmitting) return;

                        this.lockSubmit(true);

                        sessionStorage.getItem('quiz_variant_skus');
                        JSON.parse(sessionStorage.getItem('quiz_variant_skus') || '[]');
                        location.origin;

                        if (this.klaviyoLoaded) {
                            this.pushToKlaviyo();
                        } else {
                            this.form.submit();
                        }
                    });
                }
            });
        },
        methods: {
            lockSubmit(lock) {
                this.isSubmitting = !!lock;
                if (!this._submitControls) return;

                for (const el of this._submitControls) {
                    if (lock) {
                        el.setAttribute('disabled', 'disabled');
                        el.setAttribute('aria-busy', 'true');
                        el.classList.add('btn--loading');
                        el.style.pointerEvents = 'none';
                    } else {
                        el.removeAttribute('disabled');
                        el.removeAttribute('aria-busy');
                        el.classList.remove('btn--loading');
                        el.style.pointerEvents = '';
                    }
                }

                // Optionally make the whole form inert to block Enter key on other inputs
                if (this.form) {
                    if (lock) {
                        this.form.setAttribute('data-locked', 'true');
                    } else {
                        this.form.removeAttribute('data-locked');
                    }
                }
            },
            goToNext () {
                this.$router.push({
                    name: 'Results',
                    params: {
                        age: this.value,
                        emailOptIn: false
                    }
                });
            },
            async resolveVariantSkusFromServer() {
                try {
                    // 1) Fetch all pages of the collection JSON
                    let currentPage = 1;
                    let totalPages = 1;
                    const productsPerPage = 50; // keep in sync with Results.vue
                    let allProducts = [];
                    let totalProducts = 0;

                    while (currentPage <= totalPages) {
                    const res = await fetch(
                        `/collections/quiz-products?sort_by=title-ascending&view=json&page=${currentPage}`,
                        { priority: "high" }
                    );
                    if (!res.ok) break;

                    const data = await res.json();

                    allProducts = allProducts.concat(data.products || []);
                    totalProducts = Number(data.totalProducts || allProducts.length);
                    totalPages = Math.max(1, Math.ceil(totalProducts / productsPerPage));
                    currentPage++;
                    }

                    // 2) APPLY FILTERS (same as Results.vue)
                    const params = this.$route?.params || {};

                    // collect all selected answers (excluding emailOptIn)
                    const required = new Set();
                    Object.entries(params).forEach(([key, val]) => {
                    if (!val) return;
                    if (key === "emailOptIn") return;

                    String(val)
                        .split(",")
                        .map((s) => s.trim())
                        .filter(Boolean)
                        .forEach((ans) => required.add(ans));
                    });

                    let filtered = allProducts;

                    // Must include every required answer in quiz_answers[].option
                    if (required.size) {
                    filtered = (allProducts || []).filter((p) => {
                        const answers = (p.quiz_answers || [])
                        .map((a) => a && a.option)
                        .filter(Boolean);

                        for (const needed of required) {
                        if (!answers.includes(needed)) return false;
                        }
                        return true;
                    });
                    }

                    // 3) Resolve SKUs only for filtered (shown) results
                    const skuPromises = filtered.map(async (pr) => {
                    if (pr?.variantSku) return String(pr.variantSku).trim();
                    if (pr?.sku) return String(pr.sku).trim();

                    if (pr?.handle && pr?.varientId) {
                        const r = await fetch(`/products/${pr.handle}.js`, { priority: "low" });
                        if (!r.ok) return null;

                        const prod = await r.json();
                        const variantIdNum = Number(pr.varientId);

                        const match = Array.isArray(prod?.variants)
                        ? prod.variants.find((v) => Number(v?.id) === variantIdNum)
                        : null;

                        return match?.sku ? String(match.sku).trim() : null;
                    }

                    return null;
                    });

                    const skusRaw = await Promise.all(skuPromises);

                    return Array.from(
                    new Set(skusRaw.map((s) => (s || "").trim()).filter(Boolean))
                    );
                } catch {
                    return [];
                }
            },
            async pushToKlaviyo () {
                const formData = new FormData(this.form);
                const data = {};

                // Rebuild the SKU list directly (no sessionStorage)
                const productVariantSkus = await this.resolveVariantSkusFromServer();

                Object.entries(this.$route.params).forEach(param => {
                    const key = param[0];
                    const value = param[1];

                    if (value.split(',').length > 1) {
                        data[key] = value.split(',')[0];
                        data[value.split(',')[0]] = value.split(',').toSpliced(0, 1).join(',');
                    } else {
                        data[key] = value;
                    }
                });

                data['quiz_completed_at_time'] = new Date().toISOString();
                data['variant_skus'] = productVariantSkus;
                data['quiz_variant_skus'] = productVariantSkus.join(',');

                // Replaces default key with optional `klaviyo_key`
                this.$router.options.routes.forEach(route => {
                    if (route.meta.klaviyoKey) {
                        const temp = data[route.meta.writeKey];

                        data[route.meta.klaviyoKey] = temp;
                        delete data[route.meta.writeKey];
                    }
                });

                window.klaviyo.identify({
                    'email': formData.get('contact[email]'),
                    'first_name': formData.get('contact[first_name]')
                }).then(() => {
                    window.klaviyo.track('Quiz Results', data);
                });

                // Deferred form native submission to ensure `FormData` is available for Klaviyo
                this.form.submit();
            }
        }
    }
</script>
